/**
 * @format
 */

import ManagementPage from '../../../pages/shared/ManagementPage';
import {
  FormatListBulleted,
  FormatListBulletedAdd,
  ViewModule,
} from '@mui/icons-material';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
} from '@mui/material';
import { useState } from 'react';
import { fieldSx, selectMenuProps } from '../../../pages/Team/TeamPage';
import { createModule } from '../../../core/services/admin.service';
import ListModules from '../components/ListModules';
import { MODULE_LIST } from '../../../constants/commons';

const TABS = [
  { value: 1, icon: <FormatListBulleted />, label: 'Module List' },
  { value: 0, icon: <FormatListBulletedAdd />, label: 'Create Module' },
];

const ModulePage = () => {
  const [tabIndex, setTabIndex] = useState(1);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const [modules, setModules] = useState({
    list: [],
    activeModule: {
      id: '',
      name: '',
    },
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleSubmitModule = async function (event, module) {
    event.preventDefault();
    if (!module.id || !module.name) return;
    const payload = {
      moduleOperationName: module.id,
    };
    try {
      await createModule(payload);
      setSnackbar({
        open: true,
        message: 'Create new module',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error creating module:', error);
      setSnackbar({
        open: true,
        message: 'Something went wrong',
        severity: 'error',
      });
    }
  };

  return (
    <ManagementPage
      title="Team Management"
      icon={<ViewModule />}
      tabs={TABS}
      tabIndex={tabIndex}
      onTabChange={setTabIndex}
      snackbar={snackbar}
      onSnackbarClose={handleSnackbarClose}
    >
      {tabIndex === 1 ? (
        <ListModules modules={modules} setModules={setModules} />
      ) : (
        <CreateModules
          activeModule={modules.activeModule}
          setModules={setModules}
          handleSubmitModule={handleSubmitModule}
        />
      )}
    </ManagementPage>
  );
};

function CreateModules({ activeModule, setModules, handleSubmitModule }) {
  const moduleOptions = Object.values(MODULE_LIST).map((module) => ({
    id: module,
    name: module,
  }));
  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        maxWidth: 550,
        mx: 'auto',
        mt: 2.5,
        p: 2.5,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        background:
          'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
        color: 'white',
      }}
    >
      <Stack
        component="form"
        spacing={2.5}
        onSubmit={(even) => handleSubmitModule(even, activeModule)}
      >
        <FormControl fullWidth sx={fieldSx} disabled={false}>
          <InputLabel id="team-client-label">Module</InputLabel>
          <Select
            labelId="team-client-label"
            value={activeModule.id}
            label="Client"
            onChange={(event) =>
              setModules((prev) => ({
                ...prev,
                activeModule: {
                  id: event.target.value,
                  name: moduleOptions.find(
                    (module) => module.id === event.target.value
                  )?.name,
                },
              }))
            }
            MenuProps={selectMenuProps}
          >
            {moduleOptions.map((module) => (
              <MenuItem key={module.id} value={module.id}>
                {module.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          type="submit"
          variant="contained"
          disabled={!activeModule.id}
          sx={{
            width: '180px',
            mt: 1,
            alignSelf: 'center',
            py: 1.2,
            fontSize: 14,
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2,
            background: '#4f8a3d',
            boxShadow: '0 4px 14px 0 rgba(79, 138, 61, 0.4)',
            '&:hover': {
              background: '#3f6f31',
              boxShadow: '0 6px 20px 0 rgba(79, 138, 61, 0.5)',
            },
            '&.Mui-disabled': {
              background: 'rgba(255,255,255,0.16)',
              color: 'rgba(255,255,255,0.45)',
              boxShadow: 'none',
            },
          }}
        >
          Create Module
        </Button>
      </Stack>
    </Paper>
  );
}

export default ModulePage;
